import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'inArray',
})
export class InArrayPipe implements PipeTransform {
  public transform(array: (string | number)[], item: string | number): boolean {
    return array.includes(item);
  }
}
